// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"59":"59c68541","144":"27e2c5df","310":"130b035e","483":"6c9df3bb","520":"3c68e01c","528":"9af0c37c","847":"4f9401e7","896":"5919cc03"}[chunkId] + ".css";
};